/**
 * Created by andrey on 09.02.2021.
 */

const Map2dDecorators = function (decorators) { 
    this.decorators = [];
    this.smileDecorators = [];
    this.largeDecorators = [];

    if (decorators) {
        decorators.forEach(function (options) {
            if (!Map2dDecoratorView.DecoratorImageExists(options)) {
                console.log(`No frame for decorator '${options.code}' at x: ${options.x}, y: ${options.y}`);
                return;
            }

            const decorator = new Map2dDecorator(options);
            this.addDecorator(decorator.x, decorator.y, decorator);
        }, this);
    }

    if (!cleverapps.config.adminMode) {
        this.smile = new Smile(this.getSmiles.bind(this), {
            interval: 400,
            probability: 0.4
        });
        this.smile.start();
    }
};

Map2dDecorators.prototype.destructor = function () {
    if (this.smile) {
        this.smile.stop();
    }
};

Map2dDecorators.prototype.getLargeDecorators = function () {
    return this.largeDecorators;
};

Map2dDecorators.prototype.getSmiles = function () {
    return this.smileDecorators.filter((decorator) => decorator.canSmile());
};

Map2dDecorators.prototype.addDecorator = function (x, y, decorator, index) {
    if (!this.decorators[y]) {
        this.decorators[y] = {};
    }
    if (!this.decorators[y][x]) {
        this.decorators[y][x] = [];
    }

    if (index === undefined) {
        index = this.decorators[y][x].length;
    }
    this.decorators[y][x].splice(index, 0, decorator);

    this.decorators[y][x].forEach((decorator, index) => {
        decorator.decoratorZIndex = index + 1;
    });

    if (decorator.hasSmile()) {
        this.smileDecorators.push(decorator);
    }

    if (decorator.isLarge()) {
        this.largeDecorators.push(decorator);
    }
};

Map2dDecorators.prototype.removeDecorator = function (x, y, decorator) {
    if (this.decorators[y] && this.decorators[y][x]) {
        cc.arrayRemoveObject(this.decorators[y][x], decorator);
    }

    cc.arrayRemoveObject(this.smileDecorators, decorator);
    cc.arrayRemoveObject(this.largeDecorators, decorator);
};

Map2dDecorators.prototype.getDecorators = function (x, y) {
    return this.decorators[y] && this.decorators[y][x];
};

Map2dDecorators.prototype.iterateDecorators = function (iterator) {
    this.decorators.forEach((row) => {
        Object.values(row).forEach((decorators) => {
            if (decorators) {
                decorators.forEach((decorator) => {
                    iterator(decorator);
                });
            }
        });
    });
};

Map2dDecorators.prototype.hasView = function (layerId, x, y) {
    const decorators = this.getDecorators(x, y);
    return decorators && decorators.some((decorator) => decorator.getLayerId() === layerId);
};

Map2dDecorators.prototype.addDecoratorsViews = function (x, y) {
    const decorators = this.getDecorators(x, y);
    if (!decorators || cleverapps.config.debugMode && !Map2d.decoratorsVisible) {
        return;
    }

    for (let i = 0; i < decorators.length; i++) {
        const decorator = decorators[i];
        const view = decorator.getView();
        if (!view) {
            decorator.createView();
        }
    }
};

Map2dDecorators.getClimbableAction = function (unit, silent) {
    const triggers = Map2dDecorators.CLIMBABLE_TRIGGERS[cleverapps.meta.selectedLocationId()];
    if (!triggers) {
        return;
    }

    const triggerCodes = Object.keys(triggers).filter((triggerKey) => Unit.Equals(triggers[triggerKey], unit));

    if (!triggerCodes.length) {
        return;
    }

    const climbableDecorators = [];
    Map2d.currentMap.decorators.iterateDecorators((decorator) => {
        if (triggerCodes.includes(decorator.code)) {
            climbableDecorators.push(decorator);
        }
    });

    return function (f) {
        climbableDecorators.forEach((decorator) => {
            decorator.setAnimation("climbable", silent, { callback: f, changeAnimation: "change" });
        });
    };
};

Map2dDecorators.CreateCinematic = function (unit) {
    return Map2dDecorators.getClimbableAction(unit, false);
};

Map2dDecorators.CLIMBABLE_TRIGGERS = {};
